/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Of_Room_FocusInputs */

const en_of_room_focus = /** @type {(inputs: Of_Room_FocusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Focus area`)
};

const id_of_room_focus = /** @type {(inputs: Of_Room_FocusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Area fokus`)
};

/**
* | output |
* | --- |
* | "Focus area" |
*
* @param {Of_Room_FocusInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const of_room_focus = /** @type {((inputs?: Of_Room_FocusInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Of_Room_FocusInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_of_room_focus(inputs)
	return en_of_room_focus(inputs)
});